import React from 'react'
import bg1 from '../../../../../assets/images/home/bgred.svg'
import lineupskill from '../../../../../assets/images/home/lineupskill.png'


const PlatForms = ({ features }) => {
    return (
        <>
            <div className="platforms">
                <img src={bg1} className='img-fluid bg1' alt="" />
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="pltbox">
                                <img src={lineupskill} className='linefr' alt="" />
                                <div className="row justify-content-center align-items-center">
                                    <div className="col-md-10 text-center">
                                        <h3 className='text-danger'>{features?.heading}</h3>
                                        <p>{features?.paragraph}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    {features?.sections.map((item, index) => (
                                        <div className="col-md-3 mt-5" key={index}>
                                            <div className="pltboxcont">
                                                <div className="thumbng">
                                                    <img src={item.image} alt="" />
                                                </div>
                                                <h6 dangerouslySetInnerHTML={{ __html: item.heading}} />
                                                <p dangerouslySetInnerHTML={{ __html: item.paragraph}} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PlatForms
